var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._g(_vm._b({attrs:{"type":"text","label":_vm.label,"placeholder":_vm.placeholder,"value":_vm.value,"persistent-hint":""},scopedSlots:_vm._u([{key:"message",fn:function(ref){
var message = ref.message;
return [_c('italic-subheader',{attrs:{"translation-path":message}})]}}])},'v-text-field',Object.assign({}, _vm.$attrs, _vm.$props),false),_vm.computedListeners))}
var staticRenderFns = []

export { render, staticRenderFns }